import { getStyleChart } from "Helpers/helpFunction";
import moment from "moment";
import imageCircle from '../../../assets/images/Common/arount-circle.svg'

const colorDefault = [
  '#4eb7d2',
  '#c52a4a',
  '#9b51e0',
  '#FC725B',
  '#04B22B',
  '#5415AB',
  '#34FCBB',
  '#DEA923',
  '#8CC7D1',
  '#8A5963',
  '#FF9329',
  '#B8CF83',
]

export const options = (data, CommnonStore) => {
  let series = [];
  if (Object.values(data?.listChart).length > 0) {
    Object.values(data?.listChart).map((item, key) => {
      if (key < 11) {
        // const color2 = getRandomColor()
        const color = colorDefault[key]
        const dataSeries = []
        let nameItem = ''
        item.map((value, m) => {
          if (!nameItem && value?.name) {
            nameItem = value?.name
          }
          if (item?.[m + 1]) {
            if (m === 0) {
              // if (item.length - 2 === m) {
              dataSeries.push({
                x: item?.[m + 1].value,
                y: value.value,
                id: Object.keys(data?.listChart)[key],
                name: value?.name,
                marker: {
                  radius: 0,
                  symbol: 'none',
                  fillColor: color,
                  states: {
                    hover: {
                      enabled: false
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                  format: '{point.id}',
                  style: {
                    color: color,
                    fontSize: '12px',
                    textOutline: 'none',
                    fontWeight: '300',
                    fontFamily: 'Inter'
                  }
                }
              });
            } else {
              dataSeries.push({
                x: item?.[m + 1].value,
                y: value.value,
                marker: {
                  radius: 3,
                  symbol: 'circle',
                  fillColor: color,
                  states: {
                    hover: {
                      radius: 3
                    }
                  }
                }
              });
            }
          }
        })

        series.push({
          id: Object.keys(data?.listChart)[key],
          name: Object.keys(data?.listChart)[key],
          // name: nameItem,
          lineColor: color,
          type: 'spline',
          data: dataSeries
        })
      }
    })
  }

  return {
    chart: {
      type: 'spline',
      backgroundColor: 'transparent',
      renderTo: 'container',
      defaultSeriesType: 'scatter',
      height: getStyleChart(CommnonStore, 'xuhuongthegioimodal').height,
      zoomType: 'xy',

      events: {
        redraw: function () {
          const chart = this;

          if (chart.series && chart.series?.length > 0) {
            chart.series.map((item, key) => {
              const keyValue = key + 1
              // const color = item?.options?.lineColor
              const id = item?.options?.id

              const item1 = document.getElementById(`path-${keyValue}`);
              const item2 = document.getElementById(`path-${keyValue}`);

              if (chart?.get(id)?.graph && id && (item1 || item2) && keyValue) {
                chart.get(id).graph.addClass(`highcharts-arrows-${keyValue}`);
              }
            })
          }
        },
        load: function () {
          const chart = this;
          var xAxis = chart.xAxis[0]
          var yAxis = chart.yAxis[0]
          const width = 400
          let widthScreenFirst = window.innerWidth
          const firstX = xAxis.toPixels(5.7) - (widthScreenFirst > 700 ? width / 2 : width / 4)
          const firstY = yAxis.toPixels(6.1) - (widthScreenFirst > 700 ? width / 2 : width / 4)

          var imageFly = chart.renderer.image(imageCircle, firstX, firstY, width, width)
            .css({ 'z-index': '999' }).add(chart.imggroup);
          setInterval(() => {
            const widthScreen = window.innerWidth
            if (xAxis.series.length > 0 && yAxis.series.length > 0) {
              imageFly.animate({
                x: xAxis.toPixels(5.7) - (widthScreen > 700 ? width / 2 : width / 4),
                y: yAxis.toPixels(6.1) - (widthScreen > 700 ? width / 2 : width / 4),
              }, {
                duration: 300,
                height: 100,
                step: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                },
                complete: function () {
                  this.attr({
                    zIndex: -1,
                    width: widthScreen > 700 ? width : width / 2,
                    height: widthScreen > 700 ? width : width / 2,
                  })
                }
              });
            }
          }, 1000)

          if (chart.series && chart.series?.length > 0) {
            chart.series.map((item, key) => {
              const keyValue = key + 1
              // const color = item?.options?.lineColor
              const id = item?.options?.id

              const item1 = document.getElementById(`path-${keyValue}`);
              const item2 = document.getElementById(`path-${keyValue}`);

              if (chart?.get(id)?.graph && id && (item1 || item2) && keyValue) {
                chart.get(id).graph.addClass(`highcharts-arrows-${keyValue}`);
              }
            })
          }
        }
      }
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      title: {
        text: ''
      },
      gridLineWidth: 0.1,
      tickLength: 0,
      lineColor: 'transparent',
      labels: {
        rotation: 0,
        enabled: false,
        x: -23,
        style: {
          color: '#ffffff'
        },
        formatter: function (res) {
          return res?.value.toFixed(1);
        }
      }
    },
    yAxis: {
      min: 0,
      max: 10,
      tickInterval: 0.5,
      title: {
        text: ''
      },
      gridLineWidth: 0.1,
      minorTickWidth: 0,
      labels: {
        rotation: 0,
        enabled: false,
        y: 15,
        style: {
          color: '#ffffff'
        },
        formatter: function (res) {
          if (res?.value !== 0) {
            return res?.value.toFixed(1);
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      formatter: function () {
        const index = this.point.index
        return `<div>
        <b>${this.series.name}</b>
        <div>Xu hướng ngày ${moment(data?.datetime?.[index].first).format('DD/MM/YYYY')}: ${this?.x}</div>
        <div>Xu hướng ngày ${moment(data?.datetime?.[index].last).format('DD/MM/YYYY')}: ${this?.y}</div>
        </div>`;
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      spline: {
        stickyTracking: false,
        lineWidth: 1.3,
        step: 'left'
      },

      series: {
        dataLabels: {
          allowOverlap: true,
        }
      }
    },
    series: series
  }
}
